export default __webpack_public_path__ + "img/8762e65a6c40fac9743e95c6f6384ca3.png";